import { LinkInfo } from './types';

export const affiliate: LinkInfo = {
  url: 'https://loudly.tolt.io',
  label: 'general:topBar:affiliate',
};
